import getNamespace from './get-namespace';

export default (message, namespaceSettings) =>
  message.replace(/\{namespace\}/, getNamespace(namespaceSettings));



// WEBPACK FOOTER //
// ./client/routes/namespace/workflow-archival/helpers/replace-namespace.js